import React from 'react';
import { Box } from '@mui/material';
import { GeometryCheck } from './GeometryCheck';
import { CFDButtons } from './CFDButtons';
import { CFDSelector } from './CFDSelector';
import { CFDStatus } from './CFDStatus';
import { CFDDownload } from './CFDDownload';

export const CFDAPIs: React.FC = () => {
  return (
    <Box component="div" sx={{ height: '100%', boxSizing: 'border-box', padding: 0.5, gap: 0.5 }}>
      <GeometryCheck />
      <CFDButtons />
      <CFDSelector />
      <CFDDownload />
      <CFDStatus />
    </Box >
  );
};
